export default __webpack_public_path__ + "79a243dab592c445b439c465a651c75a.svg";